/**
 * Converts conversation feedback data to CSV format and triggers download
 * @param {Array} feedbackData - Array of conversation feedback records
 * @param {string} filename - Name for the downloaded file
 */
export function exportConversationFeedbackToCSV(feedbackData, filename = 'conversation_feedback.csv') {
  if (!feedbackData || feedbackData.length === 0) {
    console.warn('No data to export');
    return;
  }

  // Define CSV headers based on list view and detail view (excluding conversation messages)
  const headers = [
    'Client',
    'Company',
    'User UUID',
    'Conversation ID',
    'Conversation Type',
    'Feedback Type',
    'Feedback Reasons',
    'Comment',
    'Platform',
    'App Build',
    'Device Details',
    'User Spoke',
    'Record Created',
    'Messages Count',
    'Session Duration (seconds)',
    'Daily Usage Count',
    'Lifetime Usage Count',
    'Total Tokens',
    'Input Tokens',
    'Output Tokens',
    'Cached Text Tokens',
    'Audio Input Tokens',
    'Audio Output Tokens',
    'Cached Audio Tokens',
    'Created At'
  ];

  // Convert data to CSV rows
  const rows = feedbackData.map(feedback => {
    const conversationData = feedback.conversation_data || {};
    const tokenUsage = conversationData.token_usage || {};

    return [
      feedback.client_name || 'Unknown Client',
      feedback.company_name || 'Unknown Company',
      feedback.user_uuid || '',
      feedback.conversation_id || '',
      feedback.conversation_type || '',
      feedback.feedback_type || '',
      Array.isArray(feedback.feedback_reasons) ? feedback.feedback_reasons.join('; ') : '',
      feedback.comment || '',
      conversationData.platform || '',
      conversationData.app_build || '',
      conversationData.device_details || '',
      conversationData.user_spoke ? 'Yes' : 'No',
      conversationData.successfully_created_record !== undefined ? (conversationData.successfully_created_record ? 'Yes' : 'No') : '',
      conversationData.conversation_messages ? conversationData.conversation_messages.length : 0,
      conversationData.session_duration_seconds || '',
      conversationData.daily_usage_count || 0,
      conversationData.lifetime_usage_count || 0,
      tokenUsage.totalTokens || '',
      tokenUsage.inputTokens || '',
      tokenUsage.outputTokens || '',
      tokenUsage.cachedTextTokens || '',
      tokenUsage.audioInputTokens || '',
      tokenUsage.audioOutputTokens || '',
      tokenUsage.cachedAudioTokens || '',
      feedback.created_at ? new Date(feedback.created_at).toLocaleString() : ''
    ];
  });

  // Escape CSV values (handle commas, quotes, newlines)
  const escapeCSVValue = (value) => {
    if (value === null || value === undefined) return '';
    const stringValue = String(value);
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  // Build CSV content
  const csvContent = [
    headers.map(escapeCSVValue).join(','),
    ...rows.map(row => row.map(escapeCSVValue).join(','))
  ].join('\n');

  // Create blob and trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
